module.exports = __webpack_public_path__ + "quotezone-ui/img/compareNI.6d421c9f.svg";